import {
	reject
} from 'core-js/fn/promise'

export default {
	app: {
		name: 'GW Reader writing platform',
		codeemail: 'Code',
		coderesend: 'Resend in seconds',
		resend: 'Resend',
		Chinese: 'Chinese',
		English: 'English'
	},
	menu: {
		personal_center: 'Home',
		author_management: 'Author management',
		Writer_Center: "Writer's Center",
		my_record: "Writer's Center",
		Works_management: 'Novel management',
		works_reviewer: 'Reviewer management',
		con_info: 'Contract info',
		process_view: 'View the Process',
		My_creation: 'My stories',
		new_work: 'New story',
		edit_work: 'Edit story',
		interactive_space: 'Interaction',
		data_center: "Stories' Data",
		number_readings: 'number of readings',
		Article_unlock: 'Article unlock',
		Likes: 'Likes',
		Favorites: 'Favorites',
		my_income: 'My income',
		Work_income: 'Work income',
		Translation_income: 'Translation income',
		morebook:"",
		setting: 'Setting',
		FAQs_and_Help: 'FAQs and Help',
		loginOut: 'Log out',
		messages: 'Messages',
		my_information: 'My information',
		notice: 'Notice',
		Income_breakdown: 'Income breakdown',
		Copyright_income: 'Copyright income',
		Reward_details: 'Reward details',
		total_revenue: 'total revenue',
		Incentive_money: 'Incentive money',
		Comment_details: 'Comment details',
		Comment_management: 'Comment management',
		New_setting: 'New setting',
		Sign_management: 'Apply for a contract',
		to_write: 'Create',
		my_assets: 'my assets',
		Profile_and_Account: 'Profile and Account',
		reviewerWork: 'Works',
		authorManage: 'author Manage',
		Apply_withdrawal:"Payment info",
	},
	interact: {
		confirm: 'Confirm',
		cancel: 'Cancel',
		hint: 'Tip:'
	},
	page: {
		back: 'Back',
		Please_enter_content: 'Please enter content',
		view_all: 'View All',
		empty: 'Empty',
		tabs: {
			all: 'All',
			end: 'End',
			serialize: 'Serialize'
		}
	},
	login: {
		username: 'Username',
		penname: 'PenName',
		password: 'Password',
		email: 'Email',
		your_email: 'Your Email',
		verification_code: 'Verification code',
		phone_email_error: 'Mobile number/Email Error',
		password_error: 'Password Error',
		switch_verification_code: 'Click to switch verification code',
		verification_code_error: 'Verification code error',
		forgot_password: 'Forgot Password',
		loginin: 'Log In',
		register: 'Register',
		login_sms_code: 'Login with SMS verification code',
		phone: 'Phone',
		enter_phone_number: 'Enter phone number',
		account_password_login: 'Account and password login',
		get_verification_code: 'Get code',
		password_confirmation: 'Password Confirmation',
		email_verification_code: 'E-mail verification code',
		already_member: 'Already a member',
		User_Services_Agreement: 'User Services Agreement',
		Privacy_Policy: 'Privacy Policy',
		isLogout: 'Are you sure you want to log out?',
		notmatch:'Re-enter the password'
	},
	address: {
		cn: 'China',
		us: 'United States',
		nanjing: 'Nanjing',
		chengdu: 'Chengdu',
		shenzhen: 'Shenzhen',
		guangzhou: 'Guangzhou'
	},
	personal: {
		myrecord: 'My Record'
	},
	resetpwd: {
		resetpwd: 'Peset Password',
		account: 'Account',
		verify: 'Verify',
		compelete: 'Compelete',
		number: 'Please enter your email',
		enternumber: 'Please enter the mailbox you want to retrieve',
		shiftnumber: 'Click to switch verification code',
		wrongnumber: 'Wrong Number',
		next: 'Next',
		preview: 'Preview',
		back: 'Back',
		notmatch: 'The two passwords are inconsistent',
		pwdrule: 'The password is 6-20 digits,',
		resuccess: 'resuccess', // 11111111111111111111111111111
		back2login: 'Return to the login page',
		background2login: 'After that, the system will automatically return to the login page',
		verifycode: 'Verify Code',
		codesended: 'Code Sended',
		emailcode: 'Email Code',
		codeerror: 'Code Error',
		resendinsecond: 'Resend in second',
		resend: 'Resend',
		reget: 'Reget', // 111111111
		password: 'Password',
		passwordcomfirm: 'Pass Word Comfirm',
		sended: 'Sent, please check!'
	},
	myrecord: {
		all: 'All',
		thisweek: 'This Week',
		thismonth: 'This Month',
		lastest: 'Last three months',
		time: 'Time',
		address: 'Address',
		loginstatus: 'Login Status',
		default: 'Default'
	},
	myInfomation: { // 我的信息:/writer/#/user/information
		writerId: 'Author Id',
		works: 'Works',
		stories: 'Stories',
		integral: 'Integral',
		visitors: 'Visitors',
		penName: 'Pen Name',
		realName: 'Real Name',
		realNameTip: 'Will not show on APP',
		phone: 'Phone Number',
		collection: 'Collection',
		followers: 'Followers',
		Email: 'Email',
		AboutMe: 'About Me',
		// udpateInfo: 'Edit',
		udpateInfo: 'Edit Profile',
		createNew: 'Create Now',
		cancel: 'Cancel',
		updateSucess: 'Update Sucess',
		updateFail: 'Update Fail',
		editeHeadPath: 'Edite',
		pleaseInputYourPenName: 'Please Input Your Pen Name',

		pleaseInputPhone: 'Please Input Phone',
		emailFormat: 'Email Format',
		cancel: 'Cancel',
		commit: 'Submit',
		Add_Chapters: 'Add Chapters'
	},
	likes: {
		keys: 'Keys',
		inquire: 'Inquire',
		require: 'Recalculation ',
		all: 'All',
		time: 'Time',
		composition: 'Composition',
		down: 'Down',
		up: 'Up',
		composition1: 'Composition',
		chater: 'Chapter',
		title: 'Title',
		content: 'Content',
		likes: 'Likes',
		updateTime: 'Update Time',
		num: 'Num'
	},
	privacyPolicy: {
		privacy: 'Privacy'
	},
	newWork: {
		Click_upload: 'Upload',
		only_upload: 'format:JPG，PNG，Webp within 5MB',
		composition_name: 'Title',
		composition_name1: 'Title of the story',
		author: 'Author',
		pen_name: 'Pen Name',
		translator: 'Translator',
		selection: 'Selection',
		work_type: 'Genre',
		choose: 'Select',
		writing_type: 'Length',
		objective_reader: 'Content Rating',
		bb: 'Target Audience',
		aa: 'Language',
		work_introduce: 'Blurb',
		brief_introduction: 'Please describe the synopsis and hightlights of your work in brief',
		establish_work: 'Submit',
		save: 'Save',
		cancel: 'Cancel',
		editor: 'Editor'
	},
	setup: {
		classify: 'Classify',
		choose: 'Select',
		delete_type: 'Delete Type',
		edit_type: 'Edit Type',
		new_setting: 'New Setting',
		delete: 'Selete',
		edit: 'Edit',
		classifyName: 'Classify Name',
		classifyName1: 'Classify Name',
		cancel: 'Cancel',
		sure: 'Confirm',
		title: 'Title',
		inputTitle: 'Input Title',
		content: 'Content',
		content1: 'Content'
	},
	signingManagement: {
		submit: 'Submit',
		estimateWords:'Please kindly offer total estimated word counts',
		episodeWords:'Please kindly offer the word counts per episode on average',
		content1: 'Content ',
		ContractS: 'Contract type selections',
		titles: 'BookName',
		choose: 'Select',
		waiteAudit: 'Under Review',
		pass: 'Pass',
		noPass: 'Reject',
		date: 'Date',
		content02: 'Fill in chapter content',
		content01: 'Tip: including their ages, occupations, roles, and relations with each other ',
		chooseDate: 'Choose Date',
		save: 'Save',
		reset: 'Reset',
		return: 'Return',
		BookIdea: 'Book Idea',
		BookInformation: 'Book Information',
		Description: 'Description(introduce your book to reader)',
		Title: 'Title:',
		BookID: 'Book ID:',
		AutgorsPenName: 'Pen Name',
		DailyUpdated: 'Daily Updated',
		Status: 'Status',
		PeriodEra: 'Background',
		WordsReleased: 'Words Released',
		TotalWords: 'Total Words',
		Gener: 'Genre',
		reviewState: 'Approved/Under Review',
		pass: 'Pass',
		shenhe: 'Shenhe',
		BookRating: 'Content Rating',
		StoryBackground: 'Story Background',
		Period: 'Period',
		Language: 'Language',
		objective_reader: 'Leading Gender',
		bb: 'Target Audience',
		Tags: 'Tags',
		configurationManagement: 'configuration management',
		roleManagement: 'role Management',
		TimedTaskCompensation: 'Scheduled task compensation',
		SelectTags: 'Select tags',
		description: 'Description',
		DDD: 'descriptiondescriptiondescriptiondescriptiondescriptiondescriptiondescriptiondescription',
		ApplicationInformation: 'Synopsis Details',
		ApplyTime: 'Apply Time',
		change_photo: 'Replace the picture',
		Theme: 'Theme',
		TheSetting: 'Characters` Setting',
		TheMainCharacters: 'Main Characters',
		ThePlot: 'Plot Outline',
		wmt: 'What Make The Story Special and Attractive',
		tenow: 'Total Estimated Number of Words',
		wpeoa: 'Words Per Episode On Average',
		PersonalIntroduction: 'Personal Introduction',
		Email: 'Email',
		Birthday: 'Birthday',
		Link: "Personal Facebook / instagram / Twitter / WhatsApp Link ",
		ChapterDescrition: 'Sample chapters',
		chapterStart: 'The Start Of Chapter',
		chapterMiddle: 'The Middle Of Chapter',
		chapterEnd: 'The End Of Chapter',
		chapterContent: 'Chapter',
		chaContentTip: "Please add a chapter to the writer's article",
		Opinions: 'Editor review',
		PrimaryEditor: 'Primary Editor',
		identitles: 'Identitles',
		PlotFramework: 'Plot and story skeleton',
		CharactersIntroduction: "Characters' Setting",
		points: 'Points',
		Evaluation: 'Assessment of writing skills',
		WorkHighights: "Work's Highights",
		WorkShortcomings: "Work's Shortcomings",
		WorkSource: 'Original Platform',
		URL: 'Original Platform Link',
		reviewState: 'reviewState',
		content2: 'content',
		rejectReason: 'Reasons for Rejection'
	},
	writing: {
		chater: 'Add Chapters',
		draft: 'Draft',
		issue: 'Published Chapters',
		recycle: 'Recycle',
		return: 'Return',
		carrier: 'Single chapter upload TXT',
		batch: 'Batch upload rar',
		subsection: 'Online sub volume addition',
		classification: 'Classification',
		classification1: 'Please enter the volume name',
		classificationInfo: 'Introduction to sub volume',
		inputClassification: 'Please enter the introduction of the sub volume',
		No1: 'No1',
		save: 'Save',
		cancel: 'Cancel',
		title: 'Chapter Number',
		content: 'Content',
		writeauthorWords: '1. Wish to like: Like it? Add to library! \n 2.Wish to comment: Have some idea about my story? Comment it and let me know.',
		authorWords: 'AuthorWords',
		preChapter: 'Prev',
		title1: 'Enter your Chapter Title',
		formalContent: 'Chapter Content',
		chaterContent: 'Chapter Content(Within 3k Words)',
		saveDraft: 'Save Draft',
		preview: 'Preview',
		sent: 'Send later',
		nowsent: 'Send Now',
		num: 'Chapter word counts',
		task: 'Task',
		time: 'Time',
		date: 'Date',
		sure: 'Sure',
		look: 'Look',
		close: 'Close',
		hint: 'Hint',
		conftitle: 'Are you sure you want to submit it'
	},
	loginRecord: {
		all: 'All',
		complete: 'Complete',
		series: 'Series'
	},
	message: {
		clear: 'Clear',
		messages: 'Messages',
		talk: 'Talk',
		privacy: 'Privacy'
	},
	notice: {
		allNotice: 'All Notice',
		collect: 'Collect',
		third: 'Third',
		four: 'Four',
		system: 'System'
	},
	personalCenter: {
		time: 'Time',
		ip: 'IP',
		location: 'Location',
		login: 'Login',
		momo: 'Momo',
		seemore: 'See more'
	},
	commentDetial: {
		bookName: 'BOOK NAME',
		comtent: 'Comtent',
		like: 'Like',
		total: 'Total',
		talk: 'Talk',
		talk1: '200 Comments',
		ff: 'Jiagong',
		jiaj: 'Jiajing',
		time1: '2020-10-1',
		ll: 'Huipaimapideyaojing',
		hf: '120 Replies',
		like1: '10 Likes',
		other: 'Other Reviews',
		num1: '100',
		num2: '200',
		name2: 'Title',
		time3: '2021/03/03',
		detail: 'Details'
	},
	commentManage: {
		keys: 'Keys',
		look: 'Look',
		forbid1: 'Forbidden for 7 days',
		forbid2: 'Permanent silence',
		delete: 'Delete',
		zuop: 'Works',
		time: 'By time',
		type: 'Type',
		property: 'Property',
		commentT: 'Comment time',
		reply: 'Reply',
		aaaa: 'StoryA-Z',
		down: 'Down',
		up: 'Up',
		zzz: 'Story Comment',
		comment1: 'Reader',
		nickName: 'NickName',
		likep: 'Readers',
		likess: 'Likes',
		replyss: 'Replies',
		replyp: 'Reader',
		likeTime: 'Time',
		Time1: '06/10 12:22',
		Time: '06/10 12:22',
		replyTime: 'Reply Time',
		Comment1: 'Comments',
		top: 'Top Up',
		title2: 'Ban For 7 Days',
		sure7: 'Are You Sure That The Selected Reader Would Be Banned To Comment For 7 Days?',
		sure11: 'This Reader Could Not Comment Your Works Within 7 Days',
		sure: 'Confirm',
		cancel: 'Cancel',
		delete1: 'Elete Comments',
		delete2: 'Want To Delete Selected Comments?',
		delete3: 'After Being Deleted, It Cannot Be Rescoverred'
	},
	interactiveSpace: {
		comment: 'Comment',
		num: '5000',
		choice: 'Select',
		mionth1: 'The Latest 1 Month',
		mionth2: 'The Latest 6 Months',
		year1: 'The Latest 1 Year',
		year2: 'he Latest 2 Year',
		review: 'Review Management',
		seemore: 'More',
		WorksComments: 'Works Comment',
		type: 'Type',
		commentator: 'Reader',
		nickName: 'nickName',
		dateline: 'Time',
		TIME: '06/10 12:22',
		Thumb: 'Reader',
		likenum: 'Likes',
		replies: 'Comments',
		ThumbTime: 'Time',
		replier: 'Replier',
		recoveryTime: 'Recovery Time',
		CommentProperties: 'Comment Type',
		top: 'Top Up',
		MyBookReview: 'My Book Review',
		review1: 'Write Your Comment',
		num3: '100',
		num2: '200',
		bookName: 'Title',
		time4: '2021/03/03',
		viewDetails: 'View Details'
	},
	releaseComment: {
		CommentsManage: 'Comments Manage',
		work: 'work',
		inputName: 'Input Name',
		title: 'Title',
		inputTitle: 'Input Title',
		mainBody: 'mainBody',
		InputmainBody: 'Input Main Body',
		issue: 'Issue',
		cancel: 'Cancel'
	},
	translation: {
		sort: 'Sort',
		boom: 'Pop',
		new: 'Latest',
		bookName: 'Title',
		time4: '2021/03/03',
		money: '$330',
		history: 'History',
		inpKeys: 'Please Input Key Words',
		inquire: 'Search',
		antime: 'According To Time',
		finish: 'According To Schedule',
		moneyDown: 'Descending Order',
		moneyUp: 'Increasing Order',
		all: 'All',
		end: 'Completed',
		serialize: 'Ongoing',
		works: 'Works',
		newtime: 'Update Time',
		time5: '2021/10/02',
		finish1: 'Completeness',
		progress: 'Progress',
		sum: 'Sum',
		num34: '$3434',
		type1: 'Type'
	},
	workIncome: {
		choice: 'Select',
		mionth1: 'The Latest 1 Month',
		mionth2: 'The Latest 6 Month',
		year1: 'The Latest 1 Year',
		year2: 'The Latest 2 Years',
		detailIncome: 'Income Details',
		inputc: 'Please Fill In Content',
		inquire: 'Search',
		sort: 'Sort',
		all: 'All',
		end: 'Completed',
		serialize: 'Ongoing',
		works: 'Works',
		GrossRemuneration: 'Total Income',
		Exceptionalincome: 'Gift Income',
		bounty: 'Bonus',
		Royalties: 'Royalties',
		progress: 'Status',
		Update: 'Update Time',
		viewDetails: 'Details',
		Withdraw: 'Withdraw',
		Records: 'Records',
		Time: 'Time',
		Contract_Type: 'Contract Type',
		Signing_Bonus: 'Signing Bonus',
		Daily_Update_Bonus: 'Daily Update Bonus',
		Completion_Bonus: 'Completion Bonus',
		Special_Bonus: 'Special Bonus',
		Profit: 'Profit',
		Revenue: 'Revenue',
		recordsDetails: 'recordsDetails',
		startdate: 'start date',
		endate: 'end date',
		to: 'to'

	},
	author_remuneration: {
		keys: 'Please Input Key Words',
		inquire: 'Search',
		year: 'Year',
		all: 'All',
		week: 'Within One Week',
		month: 'Within One Month',
		years: 'Within One Year',
		year1: 'Year',
		month1: 'Month',
		week1: 'Week',
		day1: 'Day',
		works: 'Works',
		m1: 'January',
		m2: 'February',
		m3: 'March',
		m4: 'April',
		m5: 'May',
		m6: 'June',
		m7: 'July',
		m8: 'August',
		m9: 'September',
		m10: 'Octorber',
		m11: 'November',
		m12: 'December',
		num34: '$3434'
	},
	bonus: {
		keys: 'Please Input Key Words',
		inquire: 'Search',
		all: 'All',
		antime: 'By Time',
		composition: 'Story A-Z',
		down: 'Descending Order',
		up: 'Increasing Order',
		composition1: 'Works',
		time: 'Time',
		CreateIncentives: 'Bonus',
		PropertyIncome: 'Gift Income',
		CreationSubsidies: 'Writing Bonus',
		MonthlyReward: 'Monthly Reward',
		EssayReward: 'Contest Bonus',
		else: 'Else',
		summation: 'Total',
		num34: '$3434'
	},
	receiptDetails: {
		detective: 'Detective',
		adfkjwkf: 'adfkjwkf',
		pageview: 'Reads',
		likenum: 'Likes',
		private: 'Follows',
		Unlock: 'Unlock Chapters',
		coin: 'Coins',
		num1: '12313',
		num2: '1213',
		num3: '3423',
		num4: '4232',
		num5: '232',
		GrossRemuneration: 'Total Income',
		Exceptionalincome: 'Gift Income',
		bounty: 'Bonus',
		Royalties: 'Royalties',
		TranslationincomeL: 'Translation Income',
		chapter: 'Chapter',
		title: 'Title',
		Gross: 'Total Income',
		ExceptionalNumber: 'Gifts Amount',
		money: '$30.00',
		money1: '$3434',
		remark: 'Remark',
		amount: 'Amount',
		paypalRegion: 'PaypalRegion',
		receiver_Name: "Receiver's Name",
		bank_Account_No: 'Bank Account No.',
		paypalEmail: 'paypalEmail',
		paypalRecvierName: 'paypalRecvierName',
		bankCode: 'bankCode',
		bankCode: 'bankCode',
		bankEmailAddress: 'bankEmailAddress',
		bankContactEmail: 'bankContactEmail',
		userName: 'User Name',
		bankCitizenship: 'Bank Region',
		createDateTime: 'Time',
		status: 'Status'
	},
	copyright: {
		keys: 'Please Input Key Words',
		inquire: 'Search',
		sign: 'Contract Types',
		num1: '1111',
		num2: '2222',
		num3: '3333',
		num4: '4444',
		typeWorks: 'Genre',
		ZM1: 'ffff',
		ZM2: 'qqqq',
		ZM3: 'cccc',
		ZM4: 'aaaa',
		all: 'All',
		timeContract: 'Signed Date',
		antime: 'By Time',
		composition: 'Story A-Z',
		down: 'Descending Order',
		up: 'Increasing Order',
		numericalOrder: 'No.',
		works: 'Stories',
		money1: '$3434',
		CopyrightBuyer: 'Licensee',
		CopyrightAmount: 'Price',
		timeContract: 'Signed Date',
		history: 'history'
	},
	reward: {
		keys: 'Please Input Key Words',
		inquire: 'Search',
		all: 'All',
		antime: 'By Time',
		composition: 'Story A-Z',
		down: 'Descending Order',
		up: 'Increasing Order',
		numericalOrder: 'No.',
		Exceptional: 'Gifts Sender',
		name: 'Name',
		ExceptionalTime: 'Gift Time',
		ExceptionalWork: 'Book Title',
		ExceptionalNumber: 'Gifts Amount',
		num1: '$30',
		remark: 'Remark',
		num34: '$3434'
	},
	articleUnlock: {
		keys: 'Please Input Key Words',
		inquire: 'Search',
		rangeSeparator: 'To',
		startPlaceholder: 'Start Date',
		endPlaceholder: 'End Date',
		works: 'Works',
		chapter: 'Chapter',
		title: 'Title',
		synopsis: 'Synopsis',
		UnlockDBF: 'Pay Readers',
		UnlockBOOK: 'Book Coins',
		Update: 'Update Time',
		Collect: 'Follows',
		read: 'Reads'
	},
	userAgreent: {
		a1: 'User Service Protocols'
	},
	workList: {
		workCount: 'Word Count',
		VIP: 'VIP',
		status: 'Status',
		time1: 'Scheduled Publish',
		introduction: 'Blurb',
		pseudonym: 'pseudonym',
		Collect: 'Follow',
		Edit: 'Edit',
		ConceptualWork: 'Story Setting',
		SignApplication: 'Apply for a contract',
		SignProcess: 'View the process',
		published: 'Publish',
		writing: 'Create new chapters',
		choose: 'Select',
		NewSettingCategory: 'Add a New Story Setting',
		characterDesign: 'Characters Setting',
		set: 'Setting',
		otherSet: 'The Other Setting',
		DeleteCategory: 'Delete Setting',
		EditCategory: 'Edit Setting',
		newSet: 'New Setting',
		Delete: 'Delete',
		Edit: 'Edit',
		preview: 'Preview',
		NewSettingCategory: 'Creating a new Category',
		characterDesign: 'Character design',
		set: 'Set',
		otherSet: 'The other set',
		DeleteCategory: 'Delete category',
		EditCategory: 'Edit category',
		newSet: 'New set',
		Delete: 'Delete',
		Batch_upload: 'Batch Upload',
		Creation_time: 'Creation time',
		Release_time: 'Release time',
		Story_ID: 'Story ID',
		Review_Status: 'Review Status',
		Updating_Status: 'Creation time(UTC)',
		Word_Count: 'Words',
		Chapter_ID: 'Chapter_ID',
		Story_title: 'story_title',
		draft1: 'Chapter list',
		zp: 'Works',
		chater: 'Chapter',
		title: 'Title',
		synopsis: 'Synopsis',
		classification: 'Volume classification information',
		num: 'Chapter word counts',
		publishTime: 'Scheduled publishing',
		time2: 'Scheduled Release Time (UTC)',
		yes: 'Yes',
		no: 'No',
		operate: 'Operate',
		Published: 'Published',
		Modificate: 'Edit',
		restore: 'Restore',
		cancel: 'completely Cancel',
		Publish1: 'Publish in batch',
		Publish2: 'Scheduled publishing in batch',
		Publish3: 'Delete in batch',
		Publish4: 'Upload in batch',
		Publish5: 'Delete in batch',
		Publish6: 'Batch upload'
	},
	error: {
		error1: "Sorry, I can't find the page",
		return: 'Return Home'
	}
}